var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("@chakra-ui/react");
var react_2 = __importStar(require("react"));
var queries_1 = require("./__generated__/queries");
var react_infinite_scroller_1 = __importDefault(require("react-infinite-scroller"));
function songRow(_a) {
    var id = _a.id, track = _a.track;
    var song = track.song;
    var songName = song.name, disc = song.disc, artist = song.artist;
    var album = disc.album;
    var albumName = album.name, circle = album.circle;
    var tlmcArtist = artist.tlmc[0];
    var artistName = tlmcArtist.__typename === 'TlmcArtist' ? tlmcArtist.name : 'Unknown';
    var tlmcCircle = circle.tlmc[0];
    var circleName = tlmcCircle.__typename === 'TlmcCircle' ? tlmcCircle.name : 'Unknown';
    return (react_2.default.createElement(react_1.Tr, { key: id, color: id === 0 ? 'primary.700' : id === 1 ? 'primary.800' : 'black' },
        react_2.default.createElement(react_1.Td, null, id),
        react_2.default.createElement(react_1.Td, null, songName),
        react_2.default.createElement(react_1.Td, null, albumName),
        react_2.default.createElement(react_1.Td, null, artistName),
        react_2.default.createElement(react_1.Td, null, circleName)));
}
var Playlist = function () {
    var _a;
    var _b = queries_1.useDeckInfoQuery(), deckData = _b.data, deckLoading = _b.loading, deckError = _b.error;
    var _c = queries_1.usePlaylistQuery({
        variables: {
            limit: 8,
        },
    }), data = _c.data, loading = _c.loading, error = _c.error, refetch = _c.refetch, fetchMore = _c.fetchMore;
    var sortedDecks = react_2.useMemo(function () {
        /* Get the decks or empty list */
        return ((deckData === null || deckData === void 0 ? void 0 : deckData.decks) || sortedDecks || [])
            /* Clone the deck prior to sorting */
            .slice()
            /* Sort the decks on playing status */
            .sort((function (a, b) { return b.playing !== a.playing ? (b.playing ? 1 : -1) : 0; }))
            /* Correct the id to the index (in accordance with playlist id) */
            .map(function (_a, idx) {
            var id = _a.id, rest = __rest(_a, ["id"]);
            return (__assign({ id: idx }, rest));
        });
    }, [deckData]);
    var sortedPlaylist = react_2.useMemo(function () {
        var _a;
        /* Get the playlist */
        return (((_a = data === null || data === void 0 ? void 0 : data.playlist) === null || _a === void 0 ? void 0 : _a.edges) || (sortedPlaylist && sortedPlaylist.map(function (item) { return ({ node: item }); })) || [])
            /* Add the length of the deck count to correct for the slots in the decks */
            .map(function (_a) {
            var _b = _a.node, id = _b.id, rest = __rest(_b, ["id"]);
            return (__assign({ id: id + sortedDecks.length }, rest));
        });
    }, [data, sortedDecks]);
    react_2.useEffect(function () {
        refetch();
    }, [deckData]);
    var loadMore = function () {
        var _a;
        if ((_a = data === null || data === void 0 ? void 0 : data.playlist) === null || _a === void 0 ? void 0 : _a.pageInfo.hasNextPage) {
            fetchMore({
                variables: {
                    after: data === null || data === void 0 ? void 0 : data.playlist.pageInfo.endCursor,
                }
            });
        }
    };
    return (react_2.default.createElement(react_1.Table, null,
        react_2.default.createElement(react_1.Thead, null,
            react_2.default.createElement(react_1.Tr, null,
                react_2.default.createElement(react_1.Th, null, "Position"),
                react_2.default.createElement(react_1.Th, null, "Song"),
                react_2.default.createElement(react_1.Th, null, "Artist"),
                react_2.default.createElement(react_1.Th, null, "Album"),
                react_2.default.createElement(react_1.Th, null, "Circle"))),
        react_2.default.createElement(react_infinite_scroller_1.default, { loadMore: loadMore, hasMore: (_a = data === null || data === void 0 ? void 0 : data.playlist) === null || _a === void 0 ? void 0 : _a.pageInfo.hasNextPage, loader: react_2.default.createElement(react_1.Tr, null,
                react_2.default.createElement(react_1.Td, { colSpan: 5 },
                    react_2.default.createElement(react_1.Alert, { status: "info" }, "Loading more..."))), element: "tbody" },
            deckError
                ?
                    react_2.default.createElement(react_1.Alert, { status: "error" }, deckError.message)
                :
                    deckLoading || !deckData ? react_2.default.createElement(react_1.Alert, { status: "info" }, "Loading...")
                        :
                            sortedDecks.map(songRow),
            error ?
                error.message.split('\n').map(function (line, idx) { return react_2.default.createElement(react_1.Tr, null,
                    react_2.default.createElement(react_1.Td, { colSpan: 5 },
                        react_2.default.createElement(react_1.Alert, { status: "error", key: idx }, line))); }) :
                loading && !data ? react_2.default.createElement(react_1.Tr, null,
                    react_2.default.createElement(react_1.Td, { colSpan: 5 },
                        react_2.default.createElement(react_1.Alert, { status: "info" }, "Loading...")))
                    : sortedPlaylist.map(songRow))));
};
exports.default = Playlist;
//# sourceMappingURL=Playlist.js.map